export default __webpack_public_path__ + "static/media/search-white.da344439.svg";